import RemoveTradeAccountPartnerCodeForm from './RemoveTradeAccountPartnerCodeForm';

export default RemoveTradeAccountPartnerCodeForm;
